// extracted by mini-css-extract-plugin
export default {"info":"BulkImportContacts_info__MTnPW","dropzone":"BulkImportContacts_dropzone__xAxNz","confirm-modal":"BulkImportContacts_confirm-modal__5JYn5"};